/**
 * Great-circle distance helpers. Extracted from `WaterSourcesPage.tsx`
 * (the only prior implementation) so the map search's "distance from here"
 * column can share it instead of a third copy.
 */

const EARTH_RADIUS_KM = 6371;

/** Great-circle distance between two [lat, lng] points, in kilometres. */
export function haversineKm(
  [lat1, lng1]: [number, number],
  [lat2, lng2]: [number, number],
): number {
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return EARTH_RADIUS_KM * 2 * Math.asin(Math.sqrt(a));
}

/** `"340 m"` under 1km, else `"1.2 km"`. */
export function formatDistance(km: number): string {
  return km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(1)} km`;
}
